export const TIMESLOTS_DAY_GET_REQUESTED = 'TIMESLOTS_DAY_GET_REQUESTED';
export const TIMESLOTS_DAY_GET_SUCCEED = 'TIMESLOTS_DAY_GET_SUCCEED';
export const TIMESLOTS_DAY_GET_FAILED = 'TIMESLOTS_DAY_GET_FAILED';

export const TIMESLOTS_GET_REQUESTED = 'TIMESLOTS_GET_REQUESTED';
export const TIMESLOTS_GET_SUCCEED = 'TIMESLOTS_GET_SUCCEED';
export const TIMESLOTS_GET_FAILED = 'TIMESLOTS_GET_FAILED';

export const TIMESLOT_DELETE_REQUESTED = 'TIMESLOT_DELETE_REQUESTED';
export const TIMESLOT_DELETE_SUCCEED = 'TIMESLOT_DELETE_SUCCEED';
export const TIMESLOT_DELETE_FAILED = 'TIMESLOT_DELETE_FAILED';

export const TIMESLOTS_DELETE_REQUESTED = 'TIMESLOTS_DELETE_REQUESTED';
export const TIMESLOTS_DELETE_SUCCEED = 'TIMESLOTS_DELETE_SUCCEED';
export const TIMESLOTS_DELETE_FAILED = 'TIMESLOTS_DELETE_FAILED';

export const TIMESLOT_BLOCK_REQUESTED = 'TIMESLOT_BLOCK_REQUESTED';
export const TIMESLOT_BLOCK_SUCCEED = 'TIMESLOT_BLOCK_SUCCEED';
export const TIMESLOT_BLOCK_FAILED = 'TIMESLOT_BLOCK_FAILED';

export const TIMESLOT_GET_REQUESTED = 'TIMESLOT_GET_REQUESTED';
export const TIMESLOT_GET_SUCCEED = 'TIMESLOT_GET_SUCCEED';
export const TIMESLOT_GET_FAILED = 'TIMESLOT_GET_FAILED';

export const TIMESLOT_UNBLOCK_REQUESTED = 'TIMESLOT_UNBLOCK_REQUESTED';
export const TIMESLOT_UNBLOCK_SUCCEED = 'TIMESLOT_UNBLOCK_SUCCEED';
export const TIMESLOT_UNBLOCK_FAILED = 'TIMESLOT_UNBLOCK_FAILED';

export const TIMESLOT_CREATE_REQUESTED = 'TIMESLOT_CREATE_REQUESTED';
export const TIMESLOT_CREATE_SUCCEED = 'TIMESLOT_CREATE_SUCCEED';
export const TIMESLOT_CREATE_FAILED = 'TIMESLOT_CREATE_FAILED';

export const TIMESLOT_RESET = 'TIMESLOT_RESET';

export const TIMESLOT_UPDATE_MONTH = 'TIMESLOT_UPDATE_MONTH';
